import React, { useContext, useEffect, useState } from 'react'
import { AppSettings } from '../../config/app-settings'
import { toast } from 'react-toastify'
import Loader from '../pages/loader'
import ReusableTable from '../../components/other/ReuseableTable'
import EditCreateWhitelistChannel from '../../components/WhitelistChannels/EditCreateWhitelistChannel'
import { useGetDomainsTubeWhitelistQuery, useLazyGetDomainsTubeWhitelistQuery } from '../../redux/apis/domainsManagement/domains/dMDomainsTubeWhitelistApiSlice'
import SearchAndFilterBar from '../../components/other/search/SearchAndFilterBar'
import LanguageDropdown from '../../components/LanguageDropdown'
import CountriesDropdown from '../../components/CountriesDropdown'
import DownloadAllDataButton from '../../components/other/DownloadAllDataButton'
import { can } from '../../helpers/auth'

const TubesWhitelisting = React.memo(() => {
  const context = useContext(AppSettings)

  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 })
  const [search, setSearch] = useState('')
  const [filters, setFilters] = useState({})
  const [holder, setHolder] = useState(null)
  const [edit, setEdit] = useState(false)
  const [create, setCreate] = useState(false)

  const { data, isLoading, error, isFetching } =
    useGetDomainsTubeWhitelistQuery({
      expand: ['last_updated_by', 'country', 'language', 'domain'].join(','),
      page: pagination.current,
      page_size: pagination.pageSize,
      search: search || undefined,
      ...filters
    })

  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', sorter: true },
    {
      title: 'URL',
      dataIndex: 'channel_url',
      key: 'channel_url',
      filter: true,
      filterType: 'text'
    },
    {
      title: 'Name',
      dataIndex: 'channel_name',
      key: 'channel_name',
      filter: true,
      filterType: 'text'
    },
    {
      title: 'LAST UPDATED BY',
      dataIndex: 'last_updated_by',
      key: 'last_updated_by',
      render: text => (
        <div>
          <p>
            {text?.first_name} {text?.last_name}
          </p>
        </div>
      )
    },
    {
      title: 'Country',
      dataIndex: 'country',
      key: 'country.country_name',
      filter: true,
      filterComponent: CountriesDropdown,
      render: text => <p>{text?.country_name}</p>
    },
    {
      title: 'Language',
      dataIndex: 'language',
      key: 'language.language_name',
      filter: true,
      filterComponent: LanguageDropdown,
      render: text => <p>{text?.language_name}</p>
    },
    {
      title: 'Domain',
      dataIndex: 'domain',
      key: 'domain.domain_name',
      filter: true,
      filterType: 'text',
      render: text => <p>{text?.domain_name}</p>
    },
    {
      title: 'Actions',
      dataIndex: 'id',
      key: 'actions',
      render: (_, record) => (
        <div className='flex gap-2'>
          {can('put_tubes_whitelist_channels') && (
            <button
              className='btn btn-outline-theme'
              onClick={() => handleEdit(record)}
            >
              Edit
            </button>
          )}
        </div>
      )
    }
  ]

  const handleEdit = record => {
    setHolder(record)
    setEdit(true)
  }

  const handleTableChange = paginationInfo => {
    setPagination({
      current: paginationInfo.current,
      pageSize: paginationInfo.pageSize
    })
  }

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(message => toast.error(message))
    }
  }, [error])

  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return () => {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [context])

  return (
    <div className='w-full flex flex-col'>
      <Loader isLoading={isLoading || isFetching} />

      {can('post_tubes_whitelist_channels') && create && (
        <EditCreateWhitelistChannel
          state='create'
          open={create}
          setOpen={setCreate}
          record={null}
        />
      )}
      {can('put_tubes_whitelist_channels') && edit && (
        <EditCreateWhitelistChannel
          state='edit'
          open={edit}
          setOpen={setEdit}
          record={holder}
        />
      )}

      <div className='flex mb-4'>
        <SearchAndFilterBar
          columns={columns}
          search={search}
          setSearch={setSearch}
          filters={filters}
          setFilters={setFilters}
          setPagination={setPagination}
        />
        <div className='ml-auto flex gap-4'>
          <DownloadAllDataButton
            lazyQueryHook={useLazyGetDomainsTubeWhitelistQuery}
            fileName='tubes-whitelist'
          />
          {can('post_tubes_whitelist_channels') && (
            <button
              className='btn btn-outline-theme ml-auto mb-4'
              onClick={() => setCreate(true)}
            >
              Create New Whitelist Channel
            </button>
          )}
        </div>
      </div>

      <div className='row'>
        <ReusableTable
          columns={columns}
          data={data?.data?.results}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: data?.data?.count,
            showSizeChanger: true
          }}
          onChange={handleTableChange}
        />
      </div>
    </div>
  )
})

export default TubesWhitelisting
